<template>
    <div class="table filter">
        <vxe-grid
                highlight-hover-row = true
                highlight-current-row = true
                class="grid"
                auto-resize
                v-bind="$attrs"
                v-loading="demoLoading"
                ref="filterTable"
                :border="border"
                :resizable="resizable"
                :showHeaderOverflow="showHeaderOverflow"
                :align="align"
                size="small"
                :sortConfig="sortConfig"
                :filterConfig="filterConfig"
                :editConfig="editConfig"
                :edit-rules="editRules"
                :keepSource="keepSource"
                :pagerConfig="pagerConfigs"
                :toolbarConfig="toolbarConfig"
                :sort-config="{multiple: true,remote:true}"
                :checkbox-config="checkboxConfig"
                :columns="columns"
                :data="data"
                :merge-cells="mergeCells"
                :show-footer="showFooter"
                :footer-method="footerMethod"
                :footer-span-method="footerSpanMethod"
                :footer-cell-class-name="footerCellClassName"
                @page-change="handlePageChange"
                @cell-click="handleCellClick"
                v-on="$listeners"
        >

            <template v-slot:toolbar_buttons>
                <slot name="toolbar">
                </slot>
            </template>
            <template v-slot:display_columns>
                <div class="iconBoxs">
                    <div class="iconBox" v-if="meterConfig">
                        <i class="el-icon-view" @click="openTreeTransfer"></i>
                    </div>
                    <div class="iconBox" v-if="printConfig">
                        <i class="el-icon-printer" @click="printEvent"></i>
                    </div>
                    <div class="iconBox" v-if="exportConfig">
                        <i class="el-icon-s-grid" @click="exportXlsx"></i>
                    </div>
                </div>
            </template>
            <!--vxe-grid没有使用vxe-table-colgroup的例子，所以这里自行实现-->
            <!--输入筛选-->
            <template v-slot:input_default="{ column }">
                <div class="slotBox">
                    <p class="titleBox" :style="{justifyContent:column.align?(column.align =='center'?'center':(column.align =='right'?'flex-end':'left')):align =='center'?'center':(align =='right'?'flex-end':'left')}" v-contextmenu:contextmenu @click.stop="sortChange(column)">{{column.title}}
                        <span v-if="column.sortable" class="custom-sort" :class="{'is-order': column.order}">
                            <i class="vxe-sort--asc-btn vxe-icon--caret-top" :class="[column.order === 'asc' ? 'sort--active' : '']"></i>
                            <i class="vxe-sort--desc-btn vxe-icon--caret-bottom" :class="[column.order === 'desc'? 'sort--active' : '']"></i>
                        </span>
                    </p>
                    <div class="filterBox">
                        <!--输入的筛选类型-->
                        <div class="types" v-if="!column.params.filterWayUrl">
                            <div class="filterIcon" v-if="!column.params.filterWayValue || column.params.filterWayValue == '='">=</div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == '%like'">
                                <span class="sel">ab</span>c
                            </div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == 'like'">
                                a<span class="sel">b</span>c
                            </div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == 'like%'">
                                ab<span class="sel">c</span>
                            </div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == 'not like'"> d </div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == '>'"> > </div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == '>='"> >= </div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == '<'"> < </div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == '<='"> <= </div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == 'between'"> |-| </div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == '≠'"> ≠ </div>
                            <div class="filterTypes">
                                <el-select v-model="column.params.filterWayValue" v-if="column.params.filterWay == 'str'" @change="clearFilter(column.property)">
                                    <el-option
                                            v-for="item in strTypeoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                                <el-select v-model="column.params.filterWayValue" v-if="column.params.filterWay == 'num'" @change="clearFilter(column.property)">
                                    <el-option
                                            v-for="item in numTypeoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <!--ref类型-->
                        <div class="" v-if="column.params.filterWayUrl">
                            <el-input :placeholder="column.params.filterWayPhold || '请输入'" clearable :style="{textAlign:column.align}" v-model="filterElements[column.property]" @change="refFilterChange($event,column.property,column.params)"></el-input>
                        </div>
                        <div class="filterContent" v-else-if="column.params.filterWayValue == 'between'">
                            <el-input  class="filterOther" :placeholder="column.params.filterWayPhold || '请输入'" clearable :style="{textAlign:column.align}" v-model="lessElements[column.property]" @change="lessChange($event,column.property)"></el-input>
                            —  <el-input class="filterOther" :placeholder="column.params.filterWayPhold || '请输入'" clearable :style="{textAlign:column.align}" v-model="greatElements[column.property]" @change="greatChange($event,column.property)"></el-input>
                        </div>
                        <div class="filterContent" v-else>
                            <el-input :placeholder="column.params.filterWayPhold || '请输入'" clearable :style="{textAlign:column.align}" v-model="filterElements[column.property]" @change="inputFilterChange($event,column.property)"></el-input>
                        </div>
                    </div>
                </div>
            </template>
            <!--下拉筛选-->
            <template v-slot:select_default="{ column }">
                <div class="slotBox">
                    <p class="titleBox" :style="{justifyContent:align =='center'?'center':(align =='right'?'flex-end':'left')}" v-contextmenu:contextmenu @click.stop="sortChange(column)">{{column.title}}
                        <span v-if="column.sortable" class="custom-sort" :class="{'is-order': column.order}">
                            <i class="vxe-sort--asc-btn vxe-icon--caret-top" :class="[column.order === 'asc' ? 'sort--active' : '']"></i>
                            <i class="vxe-sort--desc-btn vxe-icon--caret-bottom" :class="[column.order === 'desc'? 'sort--active' : '']"></i>
                        </span>
                    </p>
                    <div class="filterBox">
                        <div class="types">
                            <div class="filterIcon" v-if="!column.params.filterWayValue || column.params.filterWayValue == '='">=</div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == 'multiple'">&</div>
                            <div class="filterTypes">
                                <el-select v-model="column.params.filterWayValue"  @change="clearFilter(column.property)">
                                    <el-option
                                            v-for="item in selectTypeoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="filterContent">
                            <!--单选-->
                            <el-select
                                    v-if="!column.params.filterWayValue || column.params.filterWayValue == '='"
                                    v-model="filterElements[column.property]"
                                    clearable
                                    @change="selectFilterChange($event,column.property,column.params.list)"
                                    :key="column.params + 1"
                                    :placeholder="column.params.filterWayPhold || '请选择'"
                            >
                                <el-option
                                        v-for="item in dicts[column.params.list]" :key="column.params.key ||item.value" :value="column.params.key || item.value" :label="column.params.value || item.label">
                                </el-option>
                            </el-select>
                            <!--多选-->
                            <el-select
                                    v-if="column.params.filterWayValue == 'multiple'"
                                    v-model="filterElements[column.property]"
                                    clearable
                                    multiple
                                    collapse-tags
                                    @change="multSelectFilterChange($event,column.property,column.params.list)"
                                    :key="column.params + 2"
                                    :placeholder="column.params.filterWayPhold || '请选择'"
                            >
                                <el-option
                                        v-for="item in dicts[column.params.list]" :key="item.value" :value="item.value" :label="item.label">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </template>
            <!--日期筛选-->
            <template v-slot:date_default="{ column }">
                <div class="slotBox">
                    <p class="titleBox" :style="{justifyContent:align =='center'?'center':(align =='right'?'flex-end':'left')}" v-contextmenu:contextmenu @click.stop="sortChange(column)">{{column.title}}
                        <span v-if="column.sortable" class="custom-sort" :class="{'is-order': column.order}">
                            <i class="vxe-sort--asc-btn vxe-icon--caret-top" :class="[column.order === 'asc' ? 'sort--active' : '']"></i>
                            <i class="vxe-sort--desc-btn vxe-icon--caret-bottom" :class="[column.order === 'desc'? 'sort--active' : '']"></i>
                        </span>
                    </p>
                    <div class="filterBox">
                        <!--输入类型-->
                        <div class="types">
                            <div class="filterIcon" v-if="column.params.filterWayValue == 'year'">Y</div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == 'month'">M</div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == 'monthrange'">M-M</div>
                            <div class="filterIcon" v-if="!column.params.filterWayValue || column.params.filterWayValue == 'date'">D</div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == 'dates'">&</div>
                            <div class="filterIcon" v-if="column.params.filterWayValue == 'daterange'">D-D</div>
                            <div class="filterTypes">
                                <el-select v-model="column.params.filterWayValue" v-if="column.params.filterWay == 'datePicker'" @change="clearFilter(column.property)">
                                    <el-option
                                            v-for="item in dateTypeoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="filterContent">
                            <el-date-picker
                                    v-if="column.params.filterWayValue == 'year'
                                     || column.params.filterWayValue == 'month'
                                     || column.params.filterWayValue == 'date'
                                     || column.params.filterWayValue == 'dates'
                                     ||!column.params.filterWayValue"
                                    v-model="filterElements[column.property]"
                                    clearable
                                    :format="dateFormat[column.params.filterWayValue || 'date']"
                                    :value-format="dateFormat[column.params.filterWayValue || 'date']"
                                    :type="column.params.filterWayValue || 'date'"
                                    :placeholder="column.params.filterWayPhold || '请选择'"
                                    @change="inputFilterChange($event,column.property)"
                                    :key="column.params + 1"
                            >
                            </el-date-picker>
                            <el-date-picker
                                    v-if="column.params.filterWayValue == 'monthrange'
                                     || column.params.filterWayValue == 'daterange'"
                                    v-model="filterElements[column.property]"
                                    :type="column.params.filterWayValue"
                                    :format="dateFormat[column.params.filterWayValue]"
                                    :value-format="dateFormat[column.params.filterWayValue]"
                                    range-separator="至"
                                    start-placeholder="开始"
                                    end-placeholder="结束"
                                    @change="inputFilterChange($event,column.property)"
                                    :key="column.params + 2"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                </div>
            </template>
            <!--默认项-->
            <template v-slot:no_filter="{ column, property, order }">
              {{column.title}}
                <!--<div class="slotBox onlyTitle">-->
                    <!--<p class="titleBox" :style="{justifyContent:align =='center'?'center':(align =='right'?'flex-end':'left')}" v-contextmenu:contextmenu @click.stop="sortChange(column)">{{column.title}}-->
                        <!--<span v-if="column.sortable" class="custom-sort custom-sort-nofilter" :class="{'is-order': column.order}">-->
                            <!--<i class="vxe-sort&#45;&#45;asc-btn vxe-icon&#45;&#45;caret-top" :class="[column.order === 'asc' ? 'sort&#45;&#45;active' : '']"></i>-->
                            <!--<i class="vxe-sort&#45;&#45;desc-btn vxe-icon&#45;&#45;caret-bottom" :class="[column.order === 'desc'? 'sort&#45;&#45;active' : '']"></i>-->
                        <!--</span>-->
                    <!--</p>-->
                <!--</div>-->
            </template>
            <!--翻译-->
            <template v-slot:trans_default="{ column, row }">
                {{row[column.property] | filtersArr(column.params.list)}}
            </template>
            <!--ref翻译-->
            <template v-slot:trans_ref="{ column, row }">
                {{row[column.property] | filtersref(column.params.list,column.params.key,column.params.label)}}
            </template>
            <!--操作列-->
            <template v-slot:operate="{ row }">
                <div class="operate">
                    <span @click="saveRowEvent(row)" v-if="$refs.filterTable.isActiveByRow(row)">保 存</span>
                    <span @click="editRowEvent(row)" v-else>编 辑</span>
                    <span @click="removeRowEvent(row)">删 除</span>
                </div>
            </template>
            <!--自定义列-->
            <template v-slot:custom="{ column,row,columnIndex,rowIndex }">
                <slot :name="column.params.slot" :column="column" :row="row" :columnIndex="columnIndex" :rowIndex="rowIndex">
                </slot>
            </template>
            <template v-slot:empty>
              <bsp-empty />
            </template>
        </vxe-grid>
        <!--右键弹出框-->
        <v-contextmenu ref="contextmenu" @contextmenu="handleContextmenu">
            <v-contextmenu-item :disabled="JSON.stringify(filtersData) == '{}'" @click="cancelFilter">清空所有筛选条件</v-contextmenu-item>
            <v-contextmenu-submenu @submenu-show="handleSubmenuShow" title="固定">
                <v-contextmenu-item :disabled="fixed=='left'" @click="leftFix">左固定</v-contextmenu-item>
                <v-contextmenu-item :disabled="fixed=='right'" @click="rightFix">右固定</v-contextmenu-item>
                <v-contextmenu-item :disabled="fixed=='null'" @click="cancelFix">取消固定</v-contextmenu-item>
            </v-contextmenu-submenu>
        </v-contextmenu>
        <!--穿梭树-->
        <el-dialog
                title="切换列的显示"
                :visible.sync="transferDialogVisible"
                :close-on-click-modal="false"
                width="50%">
            <!--// 使用树形穿梭框组件-->
            <tree-transfer :title="title" :from_data='fromData' :to_data='toData' node_key="id" pid="prentField" :defaultProps="{label:'title'}" @add-btn='add' @remove-btn='remove' :mode='mode' height='540px' filter openAll>
            </tree-transfer>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancleTreeTransfer">取 消</el-button>
                <el-button type="primary" @click="closeTreeTransfer">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import treeTransfer from 'el-tree-transfer';
    import {mapState} from "vuex";
    import { getServerDictsMap } from "@/api/common/grid"

    // 引入xlsx
    import XLSX from 'xlsx';
    let that;
    export default {
        components:{ treeTransfer },
        inheritAttrs: false,
        data () {
            return {
                //右键状态
                fixed:null,//右键当前列的固定状态
                gridLoading:false,
                // 表格配置
                ref:"filterTable",
                sortConfig:{showIcon: false},
                filterConfig:{showIcon: false,remote: true},
                // 列头数据
                columns:[],
                //表格数据
                data:[],
                filterElements:{},//筛选值
                filterElementsRequest:{},//筛选向后台传值
                filtersData:[],//筛选的方式
                lessElements:[],//分段的筛选，最小值
                greatElements:[],//分段的筛选，最大值
                // 解决多维数据的参数获取问题
                // 筛选方法
                // 字符串筛选 filterWay:str;filterWayValue:like(默认为包含)
                strTypeoptions:[ {
                    value: '=',
                    label: '等于'
                }, {
                    value: '%like',
                    label: '首部'
                },{
                    value: 'like%',
                    label: '尾部'
                },{
                    value: 'like',
                    label: '包含'
                }, {
                    value: 'not like',
                    label: '不包含'
                }],
                // 数字筛选 filterWay:num;filterWayValue:=(默认为等于)
                numTypeoptions:[ {
                    value: '=',
                    label: '等于'
                }, {
                    value: '>',
                    label: '大于'
                }, {
                    value: '>=',
                    label: '大于等于'
                }, {
                    value: '<',
                    label: '小于'
                }, {
                    value: '<=',
                    label: '小于等于'
                },{
                    value: 'between',
                    label: '介于'
                },{
                    value: '≠',
                    label: '不等于'
                }],
                //下拉筛选 filterWay:select;filterWayValue:=/multiple
                selectTypeoptions:[ {
                    value: '=',
                    label: '等于'
                }, {
                    value: 'multiple',
                    label: '多选'
                }],
                //时间筛选 filterWay:date;filterWayValue:date(默认为年月日)
                dateTypeoptions:[ {
                    value: 'year',
                    label: '年'
                }, {
                    value: 'month',
                    label: '年月'
                }, {
                    value: 'monthrange',
                    label: '月份范围'
                },{
                    value: 'date',
                    label: '年月日'
                },{
                    value: 'daterange',
                    label: '日期范围'
                },{
                    value: 'dates',
                    label: '多个日期'
                }],
                //数据格式化
                dateFormat:{
                    date:"yyyy-MM-dd",
                    dates:"yyyy-MM-dd",
                    year:"yyyy",
                    month:"yyyy-MM",
                    monthrange:"yyyy-MM",
                    daterange:"yyyy-MM-dd",
                },
                // 穿梭树
                mode: "transfer",
                title:['未显示列','显示列'],
                fromData:[],//未显示列
                toData:[],//显示列
                fromDataTemp:null,//未显示列暂存
                toDataTemp:null,//显示列暂存
                addObj:null,//新选中的列头数据
                removeObj:null,//新隐藏的列头数据
                // 弹框
                transferDialogVisible:false,
                exporting:false,//正在导出
                gridPage:{
                    currentPage: 1,
                    pageSize: 100,
                },
                orders:[],//排序
            }
        },
        props:{
            border:{
                type: Boolean,
                default: true
            },
            resizable:{
                type: Boolean,
                default:true
            },
            showHeaderOverflow:{
                type: Boolean,
                default:true
            },
            showOverflow:{
              type: Boolean,
              default:true
            },
            autoResize:{
                type: Boolean,
                default:true
            },
            keepSource:{
                type: Boolean,
                default:true
            },
            align:{
                type: String,
                default: 'center'
            },
            editConfig:{
                type: Object,
                default:() => {
                    return {
                        trigger: 'manual',
                        mode: 'row',
                        showStatus: true,
                        icon: 'fa fa-file-text-o'
                    }
                }
            },
            editRules: {
              type: Object,
              default() {
                return {}
              }
            },
            toolbarConfig:{
                type: Object,
                default:() => {
                    return {
                      enabled:false,
                        // slots: {
                        //     buttons: 'toolbar_buttons',//左边按钮
                        //     tools:"display_columns"//右边导出、打印、动态表头功能
                        // }
                    }
                }
            },
            tableColumns:{
                type: Array,
                default:() => {
                    return []
                }
            },
            tableDatas:{
                type: Array,
                default:() => {
                    return []
                }
            },
            pagerConfig: {
                type: Object,
                default(){
                  return null
                }
            },
            // 动态表头
            meterConfig:{
                type: Boolean,
                default:false
            },
            // 打印按钮
            printConfig:{
                type: Boolean,
                default:false
            },
            // 导出按钮
            exportConfig:{
                type: Boolean,
                default:false
            },
            // loading
            demoLoading:{
                type: Boolean,
                default:true
            },
            // 合并单元格
            mergeCells: {
              type: Array,
              default() {
                return []
              }
            },
            // 表格复选框
            checkboxConfig: {
              type: Object,
              default() {
                return {
                  trigger: 'default',
                  highlight: true,
                  range: true
                }
              }
            },
            showFooter: {
              type: Boolean,
              default() {
                return false
              }
            },
            // 表尾合计行
            footerMethod: {
              type: Function,
              default() {
                return null
              }
            },
            // 表尾合计行
            footerSpanMethod: {
              type: Function,
              default() {
                return null
              }
            },
            // 表尾自定义不同列颜色
            footerCellClassName: {
              type: String,
              default() {
                return 'footer-style';
              }
            }
        },
        computed:{
            ...mapState({
                dicts: (state) => state.dicts
            }),
            pagerConfigs() {
              let pagerConfig = {};
              if (this.pagerConfig) {
                return {
                  enabled: this.pagerConfig.enabled || true,
                  total: this.pagerConfig.total || 0,
                  currentPage: this.pagerConfig.page || 1,
                  pageSize: this.pagerConfig.limit || 20,
                  pageSizes: this.pagerConfig.pageSizes || [10, 20, 50, 100, 200, 500]
                }
              } else {
                return undefined
              }
            }
        },
        watch:{
            tableColumns:{
                handler(newVal, oldVal) {
                    let tableColumns = newVal;
                    tableColumns.forEach(item => {
                      item.showOverflow = item.showOverflow == undefined ? this.showOverflow : item.showOverflow;
                    })
                    this.columns = tableColumns;
                    this.getColumn();
                },
                deep: true,
                immediate:true
            },
            tableDatas:{
                handler(newVal, oldVal) {
                    this.data = this.tableDatas;
                },
                deep: true,
                immediate:true
            },
        },
        filters: {
            filtersArr: function (value,list) {
                let data = that.dicts[list].find(item =>{
                    return item.value == value
                })
                if(!data){
                    return value;
                }
                return data.label
            },
            filtersref: function (value,list,key = "value",label = "label") {
                let data = list.find(item =>{
                    return item[key] == value
                })
                if(!data){
                    return value;
                }
                return data[label]
            },
        },
        created(){
            that = this;
        },
        methods:{
            getColumn(){
                // this.$emit("update:demoLoading",true);
                this.formatColumn(this.columns);

                // 显示列头情况
                if(this.toolbarConfig&&this.toolbarConfig.slots&&this.toolbarConfig.slots.tools&&this.toolbarConfig.slots.tools == "display_columns"){
                    this.toData = this.formatTransferShow(JSON.parse(JSON.stringify(this.columns)));
                    this.fromData = this.formatTransferHide(JSON.parse(JSON.stringify(this.columns)));
                }
            },
            async formatColumn(columns){
                let result = await Promise.all(columns.map(async (item)=>{
                    return (async ()=>{
                        if(item.children){
                            this.formatColumn(item.children)
                        }else{
                            //如果有自定义列，将其slots.default 设置为custom，并将外部插槽的名字（为方便取数据，自定义的参数为外部插槽的名字）传入内部slot
                            if(item.params&&item.params.slot){
                                item.slots?item.slots:item.slots={};
                                item.slots.default = "custom"
                            }
                            // 如果列有field
                            if(item.field){
                                // 筛选情况
                                if(item.filter){
                                    // 如果写了filter为true,但没给我传filterWay,默认filter为false。
                                    item.slots?item.slots:item.slots={};
                                    switch (item.params.filterWay){
                                        case "str":
                                            item.slots.header = "input_default";
                                            break;
                                        case "num":
                                            item.slots.header = "input_default";
                                            break;
                                        case "ref":
                                            item.slots.header = "select_default";
                                            break;
                                        case "select":
                                            item.slots.header = "select_default";
                                            break;
                                        case "datePicker":
                                            item.slots.header = "date_default";
                                            break;
                                        default:
                                            item.filter = false;
                                            item.slots.header = "no_filter";
                                            break;
                                    }

                                    // 如果是ref类型，请求数据存在list
                                    if(item.filterType == "ref"){
                                        let url;
                                        if(item.params.filterWayUrl.indexOf("&") > -1){
                                            url = item.params.filterWayUrl.split("&")[0];
                                            item.params.key = item.params.filterWayUrl.split("&")[1];
                                            item.params.label = item.params.filterWayUrl.split("&")[2];
                                        }else{
                                            url = item.params.filterWayUrl;
                                        }

                                        await getServerDictsMap(url).then((list) => {
                                            item.params.list = list.data.data;
                                            item.slots.default="trans_ref";
                                            return item;
                                        })
                                    }

                                }else{
                                    // 如果没有筛选
                                    item.slots?item.slots:item.slots={};
                                    item.slots.header = "no_filter";
                                }
                            }

                            // 编辑情况(目前后台不传editRender，所以编辑只能业务页面弹框处理)
                            if(item.editRender){
                                if(item.editRender.options){
                                  if (!item.editRender.options.length) {
                                    item.editRender.options = this.dicts[item.editRender.options];
                                  }
                                  // console.log("item",item.editRender.options)
                                }
                            }
                        }
                    })()
                }))
                this.$nextTick(()=>{
                    const xTable = this.$refs.filterTable;
                    xTable.refreshColumn();
                    // 取消loading
                    // this.$emit("update:demoLoading",false);
                })
            },
            formatTransferShow(columns){
                // 分离显示列
                for (var i = columns.length - 1; i >= 0; i--) {
                    let item = columns[i];
                    if((item.visible === undefined || item.visible === true)&&item.children&&item.children.length > 0){
                        this.formatTransferShow(item.children);
                    }
                    if(item.visible === false ||((item.visible === undefined || item.visible === true) &&item.children && item.children.length == 0)){
                        columns.splice(i,1);
                    }
                }
                return columns;
            },
            formatTransferHide(columns){
                // 分离未显示列
                for (var i = columns.length - 1; i >= 0; i--) {
                    let item = columns[i];
                    if((item.visible === undefined || item.visible === true) && item.children&&item.children.length > 0){
                        this.formatTransferHide(item.children);
                    }

                    if((item.visible === undefined || item.visible === true) &&(!item.children || item.children.length == 0)  ){
                        columns.splice(i,1);
                    }
                }
                return columns;
            },
            updateColumns(columns,showColumns){
                // 设置columns
                for (var i = columns.length - 1; i >= 0; i--) {
                    let item = columns[i];
                    if(item.children){
                        this.updateColumns(item.children,showColumns);
                    }else{
                        if(item.field){
                            if( showColumns.indexOf(item.field) > -1 ){
                                item.visible = true;
                            }else{
                                item.visible = false;
                            }
                        }
                    }
                }
                return columns;
            },
            // 显示右键菜单
            handleContextmenu(vm){
                console.log(vm.elm.textContent);
                // 只能获取到点击处的标签信息，取到文字，然后查找列信息
                this.field = vm.elm.innerText;
                const xTable = this.$refs.filterTable;
                const column = xTable.getColumnByField(this.field);
                this.fixed = column.fixed?column.fixed:"null";
            },
            // 显示子菜单
            handleSubmenuShow (vm, placement) {
                console.log(vm, placement)
            },
            // 取消全部筛选
            cancelFilter(){
                const xTable = this.$refs.filterTable;
                this.columns.map(item =>{
                    item.filters = null;
                })
                this.filterElements = {};
                this.filterElementsRequest = {};

                this.filtersData = [];
                xTable.clearFilter();

                this.$emit("tableRefresh",{filters: this.filtersData, page: 0, limit: this.pagerConfigs.pageSize,orders:this.orders})
            },
            // 左固定
            leftFix () {
                const xTable = this.$refs.filterTable;
                const column = xTable.getColumnByField(this.field);
                column.fixed = "left";
                xTable.refreshColumn();
            },
            // 右固定
            rightFix () {
                const xTable = this.$refs.filterTable;
                const column = xTable.getColumnByField(this.field);
                column.fixed = "right";
                xTable.refreshColumn();
            },
            // 清除当前列固定
            cancelFix () {
                const xTable = this.$refs.filterTable;
                const column = xTable.getColumnByField(this.field);
                column.fixed = null;
                xTable.refreshColumn();
            },
            // 拼接筛选数据
            joinFilter(){
                let filtersDatas = [];
                const xTable = this.$refs.filterTable;
                for(let key in this.filterElementsRequest){
                    const column = xTable.getColumnByField(key);
                    // 空值或空数组不向后台传,null向后台传(ref)
                    if(this.filterElementsRequest[key] === null || this.filterElementsRequest[key] && this.filterElementsRequest[key].length != 0){
                        let filtersData = {};
                        filtersData.column = key;
                        filtersData.type = "and";//后台让写死
                        // 如果是ref的类型
                        if(this.filterElementsRequest[key] instanceof Array){
                            filtersData.value = this.filterElementsRequest[key].toString();
                        }else{
                            filtersData.value = this.filterElementsRequest[key];
                        }

                        if(column.params.filterWay == 'str' || column.params.filterWay == 'num' || column.params.filterWay == 'select'){
                            filtersData.operator = column.params.filterWayValue || '='
                        }else if(column.params.filterWay == 'datePicker'){
                            // filtersData.operator = column.params.filterWayValue || 'date'
                            // 如果filterWayValue不存在，或者为非区间的值
                            if(!column.params.filterWayValue || column.params.filterWayValue == 'date'  || column.params.filterWayValue == 'dates' ){
                                filtersData.operator = "=";
                            }else if( column.params.filterWayValue == 'year' || column.params.filterWayValue == 'month'  ){
                                filtersData.operator = "like";
                            }else if( column.params.filterWayValue == 'dates' ){
                                filtersData.operator = "in";
                            }else{
                                filtersData.operator = "between"
                            }
                        }
                        filtersDatas.push(filtersData);
                    }
                }
                this.filtersData = filtersDatas;

                this.$emit("tableRefresh",{filters:this.filtersData, page: 0, limit: this.pagerConfigs.pageSize,orders:this.orders})
            },
            // ref输入框回车
            refFilterChange(v,field,params){
                if(v){
                    // 模糊查找value对应的id
                    // 获取所有的list内的名字，匹配出含有的name
                    let list = params.list;
                    let name = params.label;
                    let id = params.key;
                    let names = [];
                    let values = [];
                    let map = new Map();
                    list.map(o=>{
                        map.set(o[name],o[id]);
                        o[name].indexOf(v) > -1?names.push(o[name]):"";
                    });

                    names.forEach((item)=>{
                        values.push(map.get(item));
                    })
                    if(values.length > 0){
                        v = values.toString();
                    }else{
                        v = null;
                    }
                }

                this.inputFilterChange(v,field);
            },
            // 输入框回车触发
            inputFilterChange(v,field){
                const xTable = this.$refs.filterTable;
                const column = xTable.getColumnByField(field);
                if(v){
                    if(!column.filters){
                        column.filters = [{}];
                    }

                    const option = column.filters[0];

                    if(v instanceof Array){
                        v = v.toString();
                    }
                    option.value = v;
                    option.checked = true;
                }else{
                    column.filters = undefined;
                }
                this.$set(this.filterElementsRequest,field,v);
                this.joinFilter();
            },
            // 输入框分段筛选
            inputRangeFilterChange(v,field,type){
                // {min:v,max:v}
                const xTable = this.$refs.filterTable;
                const column = xTable.getColumnByField(field);

                if(!column.filters){
                    column.filters = [{}];
                }
                const option = column.filters[0];

                option.value?option.value:option.value = {min:null,max:null};
                option.value[type] = v;
                option.checked = true;

                this.$set(this.filterElements,field,option.value);
                this.$set(this.filterElementsRequest,field,option.value);

                // 如果最大最小都为空，清除筛选
                if(!option.value["min"]&&!option.value["max"]){
                    column.filters = undefined;
                    this.$set(this.filterElements,field,"");
                    this.$set(this.filterElementsRequest,field,"");
                }
                this.joinFilter();
            },
            //输入框范围的最小值
            lessChange(v,field){
                this.inputRangeFilterChange(v,field,"min");
            },
            //输入框范围的最大值
            greatChange(v,field) {
                this.inputRangeFilterChange(v, field, "max");
            },
            // 切换类型，清空筛选
            clearFilter(field){
                this.$set(this.filterElements,field,"");
                this.$set(this.filterElementsRequest,field,"");
                const xTable = this.$refs.filterTable;
                const column = xTable.getColumnByField(field);
                column.filters = undefined;
            },
            // 下拉会触发
            selectFilterChange(v,field,list){
                const xTable = this.$refs.filterTable;
                const column = xTable.getColumnByField(field);

                if(!column.filters){
                    column.filters = [{}];
                }
                let data = [];
                that.dicts[list].map(item =>{
                    if(item.value == v){
                        item.checked = true
                    }else{
                        item.checked = false
                    };
                    data.push(item);
                })
                xTable.setFilter(column, data);
                this.$set(this.filterElementsRequest,field,v);
                this.joinFilter();
            },
            // 多选下拉会触发
            multSelectFilterChange(v,field,list){
                const xTable = this.$refs.filterTable;
                const column = xTable.getColumnByField(field);

                if(!column.filters){
                    column.filters = [{}];
                }
                let data = [];
                that.dicts[list].map(item =>{
                    if(v.indexOf(item.value) > -1){
                        item.checked = true
                    }else{
                        item.checked = false
                    };
                    data.push(item);
                })

                xTable.setFilter(column, data);
                this.$set(this.filterElementsRequest,field,v);
                this.joinFilter();
            },
            // 排序操作会触发
            sortChange ( column ) {
                column.order == null?column.order = "asc":(column.order == "asc"?column.order = "desc":column.order = null)
                if(column.sortable){
                    // 遍历如果已存在这个property，则修改，不存在新增
                    let index = this.orders.findIndex(item => {
                        return item.column == column.property;
                    })

                    if(index > -1){
                        if (column.order === 'desc' || column.order === 'asc') {
                            this.orders[index].asc = column.order === 'desc'?false:true;
                        }else{
                            this.orders.splice(index,1)
                        }
                    }else{
                        let orders = {};
                        orders.asc = column.order === 'desc'?false:true;
                        orders.column = column.property;
                        this.orders.push(orders);
                    }
                    const xTable = this.$refs.filterTable;
                    xTable.refreshColumn();
                    this.$emit("tableRefresh",{filters:this.filtersData, page: this.pagerConfigs.currentPage, limit: this.pagerConfigs.pageSize,orders:this.orders})
                    // if (column.order === 'desc') {

                        // this.$refs.filterTable.clearSort()
                    // } else if (column.order === 'asc') {
                        // this.$refs.filterTable.sort(column.property, 'desc')
                    // } else {
                        // this.$refs.filterTable.sort(column.property, 'asc')
                    // }
                }

            },
            // 分页操作会触发
            handlePageChange ({ currentPage, pageSize }) {
                // this.pagerConfig.currentPage = currentPage;
                // this.pagerConfig.pageSize = pageSize;
                this.$emit("tableRefresh",{filters: this.filtersData, page: currentPage, limit: pageSize,orders:this.orders});
            },
            // 编辑触发
            editRowEvent (row) {
                this.$refs.filterTable.setActiveRow(row)
            },
            saveRowEvent () {
                this.$refs.filterTable.clearActived().then(() => {
                    // this.gridLoading = true
                    setTimeout(() => {
                        // this.gridLoading = false
                        this.$XModal.message({ message: '保存成功！', status: 'success' })
                    }, 300)
                })
            },
            removeRowEvent (row) {
                // console.log("删除",row)
                this.$XModal.confirm('您确定要删除该数据?').then(type => {
                    if (type === 'confirm') {
                        this.$refs.filterTable.remove(row)
                    }
                })
            },
            // 动态显示列头
            openTreeTransfer(){
                this.transferDialogVisible = true;
                this.fromDataTemp = JSON.stringify(this.fromData);
                this.toDataTemp =  JSON.stringify(this.toData);
            },
            cancleTreeTransfer(){
                this.transferDialogVisible = false;
                this.fromData = JSON.parse(this.fromDataTemp);
                this.toData = JSON.parse(this.toDataTemp);
                this.addObj = null;
                this.removeObj = null;
                this.fromDataTemp = "";
                this.toDataTemp = "";
            },
            closeTreeTransfer(){
                this.transferDialogVisible = false;
                if(this.toDataTemp != JSON.stringify(this.toData)){
                    this.fromDataTemp = "";
                    this.toDataTemp = "";

                    const xTable = this.$refs.filterTable;
                    let column;
                    if(this.addObj){
                        let addKey = this.addObj.keys;
                        let addLen = this.addObj.keys.length;
                        // 遍历obj,将obj内的field转换成visible:true;
                        for(let i = 0;i < addLen ;i++){
                            column = xTable.getColumnByField(addKey[i]);
                            column?column.visible = true:"";
                        }
                    }
                    if(this.removeObj){
                        let removeKey = this.removeObj.keys;
                        let removeLen = this.removeObj.keys.length;
                        // 遍历obj,将obj内的field转换成visible:false;
                        for(let i = 0;i < removeLen ;i++){
                            column = xTable.getColumnByField(removeKey[i]);
                            column?column.visible = false:"";
                        }
                    }
                    xTable.refreshColumn();
                    // 如果field在visibleColumn里，设置false.否则设置true.
                    let show = [];
                    let showColumn = xTable.getTableColumn().visibleColumn;
                    for(let i = 0; i < showColumn.length;i++){
                        if(showColumn[i].property){
                            show.push(showColumn[i].property);
                        }
                    }
                    let columns = this.updateColumns(this.columns,show);

                    this.$emit("updateColumn",columns);
                }
                this.addObj = null;
                this.removeObj = null;
            },
            // 监听穿梭框组件添加
            add(fromData,toData,obj){
                // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
                this.addObj = obj;

            },
            // 监听穿梭框组件移除
            remove(fromData,toData,obj){
                // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
                this.removeObj = obj;

            },
            // 打印
            printEvent(){
                this.$refs.filterTable.print()
            },
            // 导出
            exportXlsx(){
                this.exporting = true;
                //创建book
                let wb = XLSX.utils.book_new();
                let ws;
                //表头
                let columns={};
                let fields = [];
                let exportColumns = [];
                let exportLists = {};
                this.tableColumns.forEach(item =>{
                    if(item.field){
                        columns[item.field] = item.title;
                        fields.push(item.field)
                    }
                    if(item.params&&item.params.list){
                        exportColumns.push(item.field);
                        exportLists[item.field]=item.params.list;
                    }
                })

                // 从第一页开始请求数据，循环页数
                let pageTotal = Math.ceil(this.pagerConfigs.total/this.pagerConfigs.pageSize);
                // let gridPage = {};
                // gridPage.total = this.pagerConfigs.total;
                // gridPage.pageSize = this.pagerConfigs.pageSize;
                // 为了减少请求次数，此处默认为100
                // gridPage.pageSize = 100;
                for(let i = 1;i < pageTotal+1;i++){
                    this.$emit("tableRefresh",{filters: this.filtersData, page: i, limit: 100,orders:this.orders}, (data)=> {
                        // 去掉不想导出的列
                        data.map(item =>{
                            delete item.id;
                            delete item._XID;
                            for(let key in item){
                                if(exportColumns.includes(key) ){
                                    let list = exportLists[key];
                                    this.dicts[list].some(item2 =>{
                                        if(item2.value == item[key]){
                                            item[key] = item2.label
                                            return true;
                                        }
                                    })

                                }
                            }
                        })

                        //json转sheet
                        // 首次插入
                        if(i == 1){
                            const newData = [columns, ...data];
                            ws = XLSX.utils.json_to_sheet(newData, {header:fields, skipHeader:true});
                        }else{
                            // 循环插入
                            XLSX.utils.sheet_add_json(ws, data, {header: fields, skipHeader: true, origin: -1});
                        }
                        if(i == pageTotal){
                            //设置列宽
                            ws['!cols'] = [];
                            for(let key in columns){
                                ws['!cols'].push({width: 15})
                            }

                            var timestamp = (new Date()).getTime();
                            //sheet写入book
                            XLSX.utils.book_append_sheet(wb, ws, "file");
                            //输出
                            XLSX.writeFile(wb,"导出"+timestamp+".xlsx");
                            this.exporting = false;
                        }
                    })
                }
            },
            // 单元格点击事件
            handleCellClick({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, triggerRadio, triggerCheckbox, triggerTreeNode, triggerExpandNode, $event }) {
                this.$emit('cell-click', { row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, triggerRadio, triggerCheckbox, triggerTreeNode, triggerExpandNode, $event});
            }
        }
    }
</script>

<style lang="scss" scoped>
    .filterBox{
        border-top:1px solid #ddd;
        padding: 4px;
        background: #ffffff;
    }
    .titleBox{
        padding:2px 10px;
        margin: 0;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
        display: flex;
        align-items: center;
        font-weight: bold;
    }
    .table .custom-sort{
        height: 20px;
    }
    .grid .slotBox{
        position: absolute;
        top: 0;
        left:0;
        bottom:0;
        width: calc(100% - 1px );
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
    }
    .grid .onlyTitle{
        justify-content: center;
    }
    .grid .vxe-cell--title{
      font-weight: bold;
        /*width: 100%;*/
    }
    .grid .el-select,.grid .el-date-editor{
        width: 100%;
    }
    .grid .el-input .el-input__inner{
        text-align: inherit;
    }
    .grid .el-select .el-input__inner{
    }
    .grid .el-date-editor .el-input__inner,.grid .el-date-editor--monthrange,.grid .el-date-editor--daterange{
        text-align: left;
    }
    .grid .el-date-editor .el-range-separator{
        display: inline-flex;
        align-items: center;
    }
    .grid .el-select .el-input .el-input__icon,.grid .el-date-editor .el-input__icon{
        display: inline-flex;
        align-items: center;
    }
    .grid .el-date-editor.el-input,.grid .el-date-editor.el-input__inner{
        width: 100%;
    }
    .grid .vxe-table .vxe-header--column{
        padding: 0!important;
    }
    /*.grid .vxe-table .vxe-header--column.col--ellipsis{*/
    /*    height: 62px;*/
    /*}*/
    .grid .vxe-table .vxe-header--column.col--ellipsis.col--group{
        height: 30px;
    }
    .el-input.filterOther{
        /*position: absolute;*/
        /*bottom:34px;*/
        /*left:38px;*/
        /*width:calc(100% - 42px);*/
        width: calc(50% - 11px);
        color: #bbb;
    }

    .table .custom-sort {
        padding: 0px 12px 2px;
        position: relative;
    }
    .table .custom-sort.is-order {
        color: #409eff;
    }
    .table .custom-sort.custom-sort-nofilter{
        padding: 0px 12px 1px;
    }
    .table .home {
        margin-top: 150px;
    }
    .table .el-transfer-panel__header {
        text-align: left;
    }
    .iconBoxs{
        display: flex;
    }
    .iconBox{
        width: 34px;
        height: 34px;
        margin-left:10px;
        border-radius: 50%;
        border:1px solid #ddd;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .iconBox:hover{
        border:1px solid #409eff;
        color:#409eff;
    }
    .iconBox i{
        font-size: 20px;
    }
    .operate{
        font-size: 12px;
        color:#333;
        display: flex;
    }
    .operate span{
        flex:0 0 50%;
        text-align: center;
    }
    .operate span:hover{
        text-decoration: underline;
        color:#409eff;
    }
    .filterContent{
        width: calc(100% - 34px);
    }
    .types{
        position: relative;
        width: 34px;
        height: 100%;
        float: left;
    }
    .filterIcon{
        width: 30px;
        margin-right: 4px;
        text-align: center;
        line-height: 28px;
        font-size: 12px;
    }
    .filterIcon .sel{
        background: #aaa;
        color:#fff;
    }
    .filterTypes{
        position: absolute;
        opacity: 0.5;
        opacity: 0;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .v-contextmenu .v-contextmenu-item.v-contextmenu-item--disabled{
        background: #ffffff;
    }
</style>
